function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import * as DeviceConstants from '../devices.constants';
import { stateGo } from 'redux-ui-router';
import { DEVICE_DETAIL_STATE_OR_NAME as CONTENT_ACTIVITY_STATE } from '../../contentActivity/content.activity.config';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { RouteParams, RouteState } from '../../../../reducers/selectors/customer.selectors';
var CustomerDevicesDetailController = /*#__PURE__*/function () {
  function CustomerDevicesDetailController($ngRedux) {
    _classCallCheck(this, CustomerDevicesDetailController);
    this.$ngRedux = $ngRedux;
    this.handleMoreOptionsSelected = this.handleMoreOptionsSelected.bind(this);
  }
  return _createClass(CustomerDevicesDetailController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          routeParams: RouteParams(store),
          routeState: RouteState(store)
        };
      };
      var controllerActions = {
        stateGo: stateGo
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.localeKeys = CustomerCareLocaleKeys;
      this.moreOptionsMenuItems = [{
        id: DeviceConstants.REMOVE_DEVICE_OPTION_ID,
        title: i18n.translate(this.localeKeys.REMOVE)
      }, {
        id: DeviceConstants.VIEW_CONTENT_ACTIVITY,
        title: i18n.translate(this.localeKeys.VIEW_CONTENT_ACTIVITY)
      }];
    }
  }, {
    key: "handleMoreOptionsSelected",
    value: function handleMoreOptionsSelected(_ref) {
      var item = _ref.item;
      switch (item.id) {
        case DeviceConstants.REMOVE_DEVICE_OPTION_ID:
          this.onRemoveDevice()();
          break;
        case DeviceConstants.VIEW_CONTENT_ACTIVITY:
          this.navigateToContentActivity();
          break;
        default:
          break;
      }
    }
  }, {
    key: "navigateToContentActivity",
    value: function navigateToContentActivity() {
      this.actions.stateGo(CONTENT_ACTIVITY_STATE, {
        deviceId: this.device.Id,
        previousRoute: {
          name: this.state.routeState.name,
          params: this.state.routeParams
        },
        deviceName: this.device.Name
      });
    }
  }, {
    key: "openUpdateDeviceModal",
    value: function openUpdateDeviceModal() {
      this.onUpdateDevice()();
    }
  }, {
    key: "isDeviceActive",
    get: function get() {
      return this.device.Active;
    }
  }, {
    key: "canEditDevice",
    get: function get() {
      return this.isDeviceActive && this.userCanEdit;
    }
  }]);
}();
export default {
  bindings: {
    currentCustomerId: '<',
    device: '<',
    userCanEdit: '<',
    onRemoveDevice: '&',
    onUpdateDevice: '&'
  },
  template: require('./devices.detail.html'),
  controller: CustomerDevicesDetailController
};